import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import MyAppTableTypes from "@/components/marketing/visuals/MyAppTableTypes";
import FullScreenButton from "@/components/marketing/visuals/FullScreenButton";

export const Route = createFileRoute("/preview/myapp-table-types")({
  component: function Preview() {
    const [expanded, setExpanded] = useState(false);
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: expanded ? "stretch" : "center",
        justifyContent: "center",
        background: "#070E1A",
      }}>
        <FullScreenButton expanded={expanded} onToggle={() => setExpanded(e => !e)} />
        <div style={{ width: "100%", maxWidth: expanded ? "none" : 900 }}>
          <MyAppTableTypes />
        </div>
      </div>
    );
  },
});
